import styled, { css } from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { mediaMinTablet } from '@root/shared/ui-kit'

import type { PremiumMeta } from '@root/entities/premium'

type Props = {
  title: string
  children: React.ReactNode
  product: PremiumMeta.PremiumProduct
}

export const PremiumInfoSection: React.FC<Props> = ({
  title,
  children,
  product,
}: Props) => (
  <Root>
    <Title $product={product}>- {title}:</Title>
    <Text>{children}</Text>
  </Root>
)

const Root = styled.div`
  &::after {
    content: '';

    margin: 10px 0;
    display: grid;
    height: 1px;

    background: linear-gradient(
      90deg,
      transparent 0%,
      var(--backgroundA-3) 48%,
      transparent 100%
    );

    ${mediaMinTablet(css`
      margin: 16px 0;
    `)}
  }

  &:last-of-type::after {
    height: 0;
  }
`

const Title = styled(Typography).attrs({
  variant: 'body2-bold',
  component: 'div',
})<{
  $product: PremiumMeta.PremiumProduct
}>`
  background: linear-gradient(
    92deg,
    ${({ $product }) =>
        $product === 'subscription'
          ? 'var(--subscriptionGradientFrom-9)'
          : 'var(--boostGradientFrom-9)'}
      0%,
    ${({ $product }) =>
        $product === 'subscription'
          ? 'var(--subscriptionGradientTo-9)'
          : 'var(--boostGradientTo-9)'}
      32.86%
  );

  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

const Text = styled.div`
  color: var(--text-12);

  span,
  a {
    color: var(--primary-9);
  }
`
